
import { Component, Vue, Watch } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import StepTemp from '@/components/StepTemp/index.vue'
import StepBasicInfo from './components/StepBasicInfo.vue'
import StepLotteryQualification from './components/StepLotteryQualification.vue'
import StepPrizeSetting from './components/StepPrizeSetting.vue'
import TipsPopup from '@/components/tipsPopup/index.vue'
import {
  createLotteryActivity,
  modifyLotteryActivity,
  getLotteryActivityDtl,
  getActivityTemplateDtl
} from '@/api/marketActivity'
import { arrAddSortNumber, defaultPrize, defaultLimit } from './../index'


@Component({
  components: {
    StepTemp,
    StepBasicInfo,
    StepLotteryQualification,
    StepPrizeSetting,
    TipsPopup
  }
})
class CreateActivity extends Vue {
  @Getter companyId!: string

  curStep = 0
  stepList = [
    {
      title: '基本信息',
      key: 0
    },
    {
      title: '抽奖资格',
      key: 1
    },
    {
      title: '奖品设置',
      key: 2
    }
  ]

  // 数据加载标志，用于强制刷新子组件
  dataLoaded = false

  // 表单数据
  formData = {
    createType: '', // 1创建活动 2创建模板
    templateName: '',
    lotteryConfigId: '',
    // 步骤一：基本信息
    lotteryName: '',
    lotteryTitle: '',
    periodType: 1, // 活动举办周期(1仅一次2每周3每月)， 默认1
    statisticsStartTime: '',
    statisticsEndTime: '',
    lotteryStartTime: '',
    lotteryEndTime: '',
    isSelfEffect: 0, // 是否自动生效(1自动生效0不自动生效)
    // 步骤二：抽奖资格
    // 消费满赠
    isConsumeQualified: 1, // 是否开启消费满赠(1开启0关闭)，默认开启
    sumCost: '',
    lotteryLimit: '',
    // 积分兑换
    isPointQualified: 0, // 是否开启积分兑换(1开启0关闭)，默认关闭
    pointExchange: '',
    // 首单满赠
    isFirstQualified: 0, // 是否开启首单满赠(1开启0关闭)，默认关闭
    firstCost: '',
    firstCostLotteryNum: '',
    // 步骤三：奖品设置
    prizeCreateType: 1,
    prizeList: [{ ...defaultPrize }],
    isParticipatePrize: 0, // 是否开启参与奖(1开启0关闭)
    participatePrizeType: 1, // 参与奖类型(1自定义2积分)
    participatePrizeTypeName: '',
    participatePrizeName: '',
    participatePrizePoint: '',
    isRequireWriteOff: 0, // 是否开启核销(1开启0关闭)
    budgetType: 1, // 预算金额类型(1固定预算2按营业额比例)，默认固定预算
    budgetMoney: '', // 奖品固定预算金额x元
    budgetRatio: '', // 奖品预算按营业额比例x%
    isLotteryLimit: 0, // 是否存在抽奖限制(1有抽奖限制0无抽奖限制)
    limitList: [{ ...defaultLimit }]
  }

  templateName = ''
  setTemplateLoading = false
  submitLoading = false
  tipsPopupContent = ''

  get isEdit() {
    return !!this.$route.query.lotteryId
  }

  @Watch('curStep')
  onCurStepChange() {
    // 让子组件刷新
    this.dataLoaded = !this.dataLoaded
  }

  created() {
    this.getDetailData()
  }

  getDetailData() {
    const { lotteryConfigId, lotteryId } = this.$route.query
    // 获取活动模板详情
    if (lotteryConfigId) {
      this.getActivityTemplateDtl(lotteryConfigId)
    }
    // 获取抽奖活动详情
    if (lotteryId) {
      this.getLotteryActivityDtl(lotteryId)
    }
  }

  // 获取活动模板详情
  getActivityTemplateDtl(lotteryConfigId: string | string[]) {
    getActivityTemplateDtl({
      storeId: this.companyId,
      lotteryConfigId
    })
      .then((res) => {
        // 合并数据，保留默认值作为兜底
        this.formData = { ...this.formData, ...(res.data || {}) }
        // 数据加载完成，触发子组件重新渲染
        this.dataLoaded = true
      })
      .catch(() => {
        // 即使失败也标记加载完成，让子组件使用默认数据渲染
        this.dataLoaded = true
        this.$toast('获取模板详情失败')
      })
  }

  // 获取抽奖活动详情
  getLotteryActivityDtl(lotteryId: string | string[]) {
    getLotteryActivityDtl({
      storeId: this.companyId,
      lotteryId
    })
      .then((res) => {
        // 合并数据，保留默认值作为兜底
        this.formData = { ...this.formData, ...(res.data || {}) }
        // 数据加载完成，触发子组件重新渲染
        this.dataLoaded = true
      })
      .catch(() => {
        // 即使失败也标记加载完成，让子组件使用默认数据渲染
        this.dataLoaded = true
        this.$toast('获取活动详情失败')
      })
  }

  // 更新表单数据
  updateFormData(data: any) {
    this.formData = { ...this.formData, ...data }
  }

  // 获取当前步骤的子组件 ref
  getStepRef(step: number) {
    const stepRefMap: Record<number, string> = {
      0: 'step0Ref',
      1: 'step1Ref',
      2: 'step2Ref'
    }
    return this.$refs[stepRefMap[step]] as any
  }

  // 验证当前步骤的子组件
  async validateStep(step: number): Promise<boolean> {
    const stepRef = this.getStepRef(step)
    if (stepRef?.validate) {
      const isValid = await stepRef.validate()
      return isValid !== false
    }
    return true
  }

  // 下一步
  async onNextStep() {
    try {
      // 先验证表单
      await (this.$refs.formRef as any).validate()

      // 验证当前步骤的子组件
      const isValid = await this.validateStep(this.curStep)
      if (!isValid) return

      if (this.curStep < 2) {
        this.curStep++
      }
    } catch {
      // 校验失败，自动显示错误提示
    }
  }

  // 上一步
  onPrevStep() {
    if (this.curStep > 0) {
      this.curStep--
    }
  }

  // 清除表单校验 - 支持单个字段、字段数组或特殊标识
  clearFormValidate(prop: string | string[]) {
    // 统一转为数组处理
    let fields: string[] = Array.isArray(prop) ? prop : [prop]

    // 特殊处理：prizeList 需要展开为具体字段路径
    if (fields.includes('prizeList')) {
      fields = fields.filter((f) => f !== 'prizeList')
      this.formData.prizeList.forEach((_: any, index: number) => {
        fields.push(
          `prizeList.${index}.prizeName`,
          `prizeList.${index}.prizePoint`,
          `prizeList.${index}.prizeCost`,
          `prizeList.${index}.prizeAmount`,
          `prizeList.${index}.prizeWinRate`
        )
      })
    }

    // 特殊处理：limitList 需要展开为具体字段路径
    if (fields.includes('limitList')) {
      fields = fields.filter((f) => f !== 'limitList')
      this.formData.limitList.forEach((_: any, index: number) => {
        fields.push(
          `limitList.${index}.limitType`,
          `limitList.${index}.limitPrizeName`,
          `limitList.${index}.limitWinRate`
        )
      })
    }

    // 清除校验
    ;(this.$refs.formRef as any).resetValidation(fields)
  }

  onSetTemplate() {
    ;(this.$refs.formRef as any)
      .validate()
      .then(async () => {
        const isValid = await this.validateStep(this.curStep)
        if (!isValid) return
        ;(this.$refs.setTemplateTipsPopupRef as any).showPopup()
      })
      .catch(() => {
        // 校验失败，自动显示错误提示
      })
  }

  onSetTemplateConfirm() {
    if (!this.templateName?.trim()) {
      ;(this.$refs.setTemplateTipsPopupRef as any).showPopup()
      this.$toast('请输入模板名称')
      return false
    }
    this.setTemplateLoading = true
    let { prizeList = [], limitList = [] } = this.formData
    prizeList = arrAddSortNumber(prizeList)
    limitList = arrAddSortNumber(limitList)
    // 设为模版
    createLotteryActivity({
      ...this.formData,
      prizeList,
      limitList,
      createType: 2, // 创建模版
      templateName: this.templateName,
      storeId: this.companyId
    })
      .then(() => {
        this.$toast('设置成功')
      })
      .catch((err) => {
        this.$toast(err.data.msg || '设置失败')
      })
      .finally(() => {
        this.setTemplateLoading = false
      })
  }

  // 投放
  onSubmit() {
    ;(this.$refs.formRef as any)
      .validate()
      .then(async () => {
        const isValid = await this.validateStep(this.curStep)
        if (!isValid) return
        this.submitLoading = true
        // 根据是否有ID判断是修改还是创建
        const apiFn = this.isEdit
          ? modifyLotteryActivity
          : createLotteryActivity
        const successMsg = this.isEdit ? '修改成功' : '投放成功'
        let { prizeList = [], limitList = [] } = this.formData
        prizeList = arrAddSortNumber(prizeList)
        limitList = arrAddSortNumber(limitList)
        apiFn({
          ...this.formData,
          prizeList,
          limitList,
          createType: 1, // 创建活动
          storeId: this.companyId
        })
          .then(() => {
            this.$toast(successMsg)
            this.$router.back()
          })
          .catch((err) => {
            this.$toast(err?.data?.msg || (this.isEdit ? '修改失败' : '投放失败'))
          })
          .finally(() => {
            this.submitLoading = false
          })
      })
      .catch(() => {
        // 校验失败，自动显示错误提示
      })
  }

  onHandleBack() {
    this.tipsPopupContent = this.isEdit ? '返回将不会保存已修改的配置，是否确认返回？' : '返回将清空已录入的配置，是否确认返回？'
    ;(this.$refs.tipsPopupRef as any).showPopup()
  }

  onHandleBackConfirm() {
    this.$router.back()
  }
}
export default CreateActivity
